module.exports = __webpack_public_path__ + "img/meituan.41aca1d1.png";